import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Form, Input, Select, Typography } from '@vivaldis/antd-ui'
import { Grid } from '../../../../../../../Grid'
import { CountryType } from '../../../../../../types/CountryType'

interface Props {
  countries: CountryType[]
}

export const PersonalInformation = ({ countries }: Props) => {
  const [t] = useTranslation('web_ui')

  const nationalityOptions = useMemo(
    () =>
      countries
        .map(country => ({
          label: country.nationality,
          value: country.id
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [countries]
  )
  return (
    <>
      <Typography.Title level={5} marginBottom={16}>
        {t(
          'edit_employee_personal_information_form.steps.edit_manually.personal_information_header'
        )}
      </Typography.Title>

      <Alert
        title={t(
          'edit_employee_personal_information_form.steps.edit_manually.alert.title'
        )}
        type="warning"
        style={{
          marginBottom: 16
        }}
      />

      <Grid columns={2} gap={0} columnGap={16} marginTop={6}>
        <Form.Item
          name="firstName"
          required
          label={t(
            'edit_employee_personal_information_form.steps.edit_manually.first_name.label'
          )}
        >
          <Input
            name="firstName"
            placeholder={t('form.required')}
            autoComplete="off"
          />
        </Form.Item>
        <Form.Item
          name="lastName"
          required
          label={t(
            'edit_employee_personal_information_form.steps.edit_manually.last_name.label'
          )}
        >
          <Input
            name="lastName"
            placeholder={t('form.required')}
            autoComplete="off"
          />
        </Form.Item>
      </Grid>

      <Grid columns={2} gap={0} columnGap={16} marginTop={6}>
        <Form.Item
          name="nationalityCountryId"
          required
          label={t(
            'edit_employee_personal_information_form.steps.edit_manually.nationality_country_id.label'
          )}
        >
          <Select
            name="nationalityCountryId"
            placeholder={t('form.required')}
            options={nationalityOptions}
            showSearch
            autoComplete="chrome-off-employee-nationality"
          />
        </Form.Item>
        <Form.Item
          name="ssn"
          required
          label={t(
            'edit_employee_personal_information_form.steps.edit_manually.ssn.label'
          )}
        >
          <Input
            name="ssn"
            placeholder={t('form.required')}
            autoComplete="off"
          />
        </Form.Item>
      </Grid>
    </>
  )
}
